import ImageDisplayElement from "./ImageDisplayElement";
import LoadingDisplay from "../../../common/LoadingDisplay/LoadingDisplay";

const DisplaySearch = ({
    templates,
    setMetaData,
    isLoading,
    selectedTemplates,
}) => {
    //loops through the selected templates or search templates
    const loadImages = (loadedImages) => {
        return (
            <ImageDisplayElement
                loadedImages={loadedImages}
                setMetaData={setMetaData}
                selectedTemplates={selectedTemplates}
            />
        );
    };

    let content = isLoading ? (
        <>
            {loadImages(templates)}
            <LoadingDisplay />
        </>
    ) : templates.length ? (
        <>{loadImages(templates)}</>
    ) : (
        <h2 style={{ textAlign: "center" }}>No Results</h2>
    );

    return content;
};

export default DisplaySearch;
